import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f37f09be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "table table-bordered",
  style: {"margin-bottom":"9px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"50%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"50%"} })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "負債の部")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "科目"),
    /*#__PURE__*/_createElementVNode("th", null, "金額")
  ])
], -1))
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "負債合計", -1))
const _hoisted_8 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_kin = _resolveComponent("input-kin")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ryudoFusaiItems, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.kmkType
          }, [
            _createElementVNode("td", null, _toDisplayString(item.kmkName), 1),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_input_kin, {
                modelValue: item.kin,
                "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                "allow-blank": true,
                disabled: _ctx.isDisabledByCorporationType(item)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
            ])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.koteiFusaiItems, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.kmkType
          }, [
            _createElementVNode("td", null, _toDisplayString(item.kmkName), 1),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_input_kin, {
                modelValue: item.kin,
                "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                "allow-blank": true,
                disabled: _ctx.isDisabledByCorporationType(item)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("tfoot", null, [
        (_ctx.fusaiGokei)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("td", _hoisted_8, [
                _createVNode(_component_input_kin, {
                  value: _ctx.formatNumberWithCommas(_ctx.fusaiGokei.kin),
                  disabled: ""
                }, null, 8, ["value"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}